import type { ReactNode } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import { ListableInfo } from '@ics-portal/guardian';
import { GET_SINGLE_COMPONENT_EXTERNAL_IDENTIFIERS } from '@api/queries/components';

interface ExternalIdentifiersProps {
    componentId: string;
    /**
     * Add the ICS Portal CPE source (use the cpeName available on a component)
     */
    icsPortalSource?: string | null;
}

export function ExternalIdentifiers({
    componentId,
    icsPortalSource,
}: ExternalIdentifiersProps): ReactNode {
    const { data } = useSuspenseQuery(
        GET_SINGLE_COMPONENT_EXTERNAL_IDENTIFIERS,
        {
            variables: { componentId },
        },
    );

    const component = data.components.edges[0]?.node;
    const externalIdentifiers = component.componentExternalIdentifiers;
    const isEmpty =
        (!externalIdentifiers || externalIdentifiers.length === 0) &&
        !icsPortalSource;

    return (
        <div className="flex flex-column gap-2 py-sm">
            {typeof icsPortalSource === 'string' &&
            icsPortalSource.length > 0 ? (
                <ListableInfo
                    key="icsPortalSource"
                    label="Source: ICS Portal"
                    value={icsPortalSource}
                    orientation="vertical"
                />
            ) : null}
            {Array.isArray(externalIdentifiers) &&
            externalIdentifiers.length > 0
                ? externalIdentifiers.map((ei) => (
                      <ListableInfo
                          key={ei.id}
                          label={`Source: ${ei.source}`}
                          value={ei.externalIdentifier}
                          orientation="vertical"
                      />
                  ))
                : null}
            {isEmpty ? <p>No external identifiers found.</p> : null}
        </div>
    );
}
